import React from "react";
import Headline from "../../../../components/Typography/Headline";
import Navigation from "../../components/Navigation";
import OngoingOrder from "../../components/OngoingOrder";
import { useUser } from "~/assets/js/Api/userApi";

const Overview = () => {
    const { user } = useUser();
    const { iconPath } = reactConfig;
    return (
        <>
            <div className="user-info">
                <img
                    src={`${iconPath}/profile-icon.svg`}
                    alt={`${user.first_name} ${user.last_name} profile`}
                    className="profile-img"
                />
                <Headline size={6} className="username">
                    {`${user.first_name} ${user.last_name}`}
                </Headline>
            </div>
            <OngoingOrder />
            <Navigation />
        </>
    );
};

export default Overview;
